import React from 'react';
import type { EmThread } from '../../email/types';
import { Icon } from '../Icon/Icon';
import { IconButton } from '../IconButton/IconButton';

export interface EmailAuditModalProps {
  thread: EmThread;
  open: boolean;
  onClose: () => void;
}

export function EmailAuditModal({ thread, open, onClose }: EmailAuditModalProps) {
  if (!open) return null;
  const np = thread.subjectTr || thread.subject;

  return (
    <>
      <div className="em-scrim" onClick={onClose} aria-hidden />
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 81,
          padding: 24,
          pointerEvents: 'none',
        }}
      >
        <div
          className="em-rise"
          style={{
            width: 'min(480px, 100%)',
            maxHeight: 'calc(100vh - 80px)',
            pointerEvents: 'auto',
            background: 'var(--cream-1)',
            border: '1px solid var(--cream-2)',
            borderRadius: 'var(--r-xl)',
            boxShadow: 'var(--sh-3)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--cream-2)', display: 'flex', alignItems: 'center', gap: 11 }}>
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: 'var(--ai-tint)',
                color: 'var(--ai-3)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
              }}
            >
              <Icon kind="clock" size={17} />
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 16,
                  fontWeight: 600,
                  color: 'var(--ink-0)',
                  letterSpacing: '-0.015em',
                }}
              >
                Audit log
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: 'var(--ink-3)',
                  marginTop: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {np}
              </div>
            </div>
            <IconButton icon="x" size={32} onClick={onClose} label="Close" />
          </div>
          <div className="cal-scroll" style={{ overflowY: 'auto', padding: '8px 12px 14px' }}>
            {thread.audit.map((a, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 11,
                  padding: '11px 8px',
                  borderBottom: i < thread.audit.length - 1 ? '1px solid var(--cream-2)' : 'none',
                }}
              >
                {a.ai ? (
                  <span
                    style={{
                      width: 26,
                      height: 26,
                      borderRadius: '50%',
                      background: 'var(--ai-tint)',
                      color: 'var(--ai-3)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flex: 'none',
                    }}
                  >
                    <Icon kind="sparkle" size={13} />
                  </span>
                ) : (
                  <span
                    style={{
                      width: 26,
                      height: 26,
                      borderRadius: '50%',
                      background: 'var(--gold)',
                      color: '#fff',
                      fontSize: 10,
                      fontWeight: 700,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flex: 'none',
                      fontFamily: 'var(--font-display)',
                    }}
                  >
                    {a.actor[0]}
                  </span>
                )}
                <span style={{ fontSize: 13, color: 'var(--ink-1)', flex: 1, lineHeight: 1.45 }}>
                  <b style={{ fontWeight: 600 }}>{a.actor}</b>{' '}
                  <span style={{ color: 'var(--ink-2)' }}>{a.action}</span>
                </span>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10.5, color: 'var(--ink-4)', flex: 'none' }}>{a.time}</span>
              </div>
            ))}
          </div>
          <div
            style={{
              padding: '11px 20px',
              borderTop: '1px solid var(--cream-2)',
              background: 'var(--cream-0)',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <Icon kind="sparkle" size={12} style={{ color: 'var(--ai-3)' }} />
            <span style={{ fontSize: 11.5, color: 'var(--ink-3)' }}>Every Elva and staff action on this thread is logged.</span>
          </div>
        </div>
      </div>
    </>
  );
}
